import api from './api';

export const calculatorService = {
  /**
   * Get calculator configuration data (AMI, FPL, SMI, tiers).
   */
  getConfig: async () => {
    const response = await api.get('/admin/calculator');
    return response.data;
  },

  saveTier: async (tierForm) => {
    const response = await api.post('/admin/calculator/tiers', tierForm);
    return response.data;
  },

  saveFplSmi: async (form) => {
    const response = await api.post('/admin/calculator/fpl-smi', form);
    return response.data;
  },

  saveFplSmiAdder: async (form) => {
    const response = await api.post('/admin/calculator/fpl-smi-adder', form);
    return response.data;
  },

  saveAmi: async (form) => {
    const response = await api.post('/admin/calculator/ami', form);
    return response.data;
  },

  saveAmiAdder: async (form) => {
    const response = await api.post('/admin/calculator/ami-adder', form);
    return response.data;
  }
};